import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PresupuestoRecuperarService {
  /**
   * @description constructor
   * @params http
   */
  constructor(
    private http: HttpClient
  ) {
    this.http = http;
  }
  /**
   * @description Recuperar presupuesto
   * @params id
   */
  getBudget(id: number): Observable<ArrayBuffer> {
    const headerConfig: any = {
      headers: new HttpHeaders()
        .append('Content-Type', 'application/x-www-form-urlencoded')
    };
    const obj: any = { idpresupuesto: id };
    headerConfig.params = new HttpParams({ fromObject: obj });

    return this.http.get(
      environment.endpoints.urlBase +
      environment.endpoints.presupuestoRecuperar.name,
      headerConfig
    );
  }
}
